import React, { useState } from 'react';
import logo from '/Logo_dashboard.webp';
import EnquiryModal from '../pages/EnquiryModal';

const Footer = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-top" style={{ paddingTop: "40px" }}>
        {/* Left - Logo & Description */}
        <div className="footer-brand">
          <div className="footer-logo">
            <div className="logo-icon">
              {/* FIX: Added explicit dimensions to fix Lighthouse warning */}
              <img 
                src={logo} 
                alt="PolicySaath Logo" 
                style={{ height: "70px", width: "auto" }}
                width="146"
                height="70"
              />
            </div>
          </div>
          <p>
            PolicySaath helps agents, agencies, and companies centralize policy records,
            track premiums, and manage renewals with accuracy and ease.
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/policysaath" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/policysaath/" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="https://www.youtube.com/@PolicySaath" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
            <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>

        {/* Middle Columns */}
        <div className="footer-links">
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><a href="#">Dashboard</a></li>
              <li><a href="#">Import Policy</a></li>
              <li><a href="#">Add New Policy</a></li>
              <li><a href="#">Family Management</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Support</h4>
            <ul>
              <li><a href="#">Help Center</a></li>
              <li><a href="#">FAQ</a></li>
              <li><a href="#contact-us">Contact us</a></li>
            </ul>
          </div>
            <div className="footer-col">
              <h4>Company</h4>
              <ul>
                <li><a href="#">About us</a></li>
                <li><a href="#">Leadership</a></li>
                <li><a href="#">Careers</a></li>
                <li><a href="#">Article & News</a></li>
                <li><a href="#">Legal Notices</a></li>
              </ul>
            </div>
        </div>

        <div id="contact-us" className="footer-newsletter">
          <h1>Contact Us</h1>
          <p>Our Team will reach out to you as soon as possible on your mail</p>
          <div className="newsletter-form">
            <button type="button" onClick={() => setShowModal(true)}>
              <i className="fas fa-paper-plane"></i> Enquiry Now
            </button>
          </div>
        </div>

        <EnquiryModal show={showModal} onClose={() => setShowModal(false)} />
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>Copyright © 2025 PolicySaath, All rights reserved.</p>
        <div className="footer-bottom-links">
          <a href="/terms-conditions">Terms & Conditions</a>
          <a href="/privacy-policy">Privacy policy</a>
          <a href="/disclaimer">Disclaimer</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;